import { isEqual } from 'lodash';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

export function filterNull<T>() {
  return (observable: Observable<T | undefined | null>) =>
    observable.pipe(
      filter((r) => r != null),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((r) => r!),
    );
}

export function distinctUntilObjectChanged<T>() {
  return (observable: Observable<T>) =>
    observable.pipe(distinctUntilChanged((a, b) => isEqual(a, b)));
}

export function tapAll<T>(action: () => void) {
  return (observable: Observable<T>) =>
    observable.pipe(
      tap(
        (v) => action(),
        (e) => action(),
        () => action(),
      ),
    );
}

type Constructor<T> = new (...args: any[]) => T;
export function filterType<T>(type: Constructor<T>) {
  return (observable: Observable<any>) =>
    observable.pipe(
      filter((obj) => obj instanceof type),
      map((obj) => obj as InstanceType<typeof type>),
    );
}
